import { RouterActionTypes } from './router.action.types';
export var NavigateToUrl = function (url, target, features, replace) { return ({
    type: RouterActionTypes.NAVIGATE_TO_URL,
    payload: {
        URL: url,
        Target: target,
        Features: features,
        Replace: replace
    }
}); };
//# sourceMappingURL=navigateToUrl.action.js.map